import { isIntake } from './copied/constants/common';
import { documentReady } from './utils/documentReady';

const host = document.createElement('section');
host.classList.add('webchatv4');
host.id = 'webchatv4';
// fix for PEP-1575
host.style.position = 'absolute';
host.style.zIndex = '1101';
host.role = 'region';

const shadowRoot = host.attachShadow({ mode: 'open' });
// create the element where we would render our app
const rootContainer = document.createElement('div');
rootContainer.id = 'root';
rootContainer.classList.toggle('client-page', !isIntake);

// append the container element inside the shadow
shadowRoot.appendChild(rootContainer);

// set the height of the app to the height of the window
// this is needed to make sure that the app is not cut off
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
function appHeight() {
  const embeddedView = document.getElementById('ostro-embed-view');

  if (embeddedView) {
    host.style.setProperty('--app-height', `${embeddedView.offsetHeight}px`);
    host.style.setProperty('--app-width', `${embeddedView.offsetWidth}px`);
    return;
  }

  host.style.setProperty('--app-height', `${window.innerHeight}px`);
  host.style.setProperty('--app-width', `${window.innerWidth}px`);
}

window.addEventListener('resize', appHeight);
appHeight();

// add root element as soon as the document body is ready
documentReady().then(() => {
  const embeddedView = document.getElementById('ostro-embed-view');

  if (embeddedView) {
    embeddedView.appendChild(host);
    return;
  }

  document.body.appendChild(host);
});

export { rootContainer, shadowRoot, host };
